<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <div>
      <div class="bg-info m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <div class="m-b-10">
                <div class="avatar"></div>
              </div>
              <h3 class="h5">Claim: {{ claimdetails.claim_unique_id }}</h3>
            </div>
          </div>
        </div>
      </div>
      <section class="pull-up">
        <div class="container" id="printDiv" ref="printNow">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30">
                <div class="card-header"></div>

                <div class="card-body">
                  <div class="form-group">
                    <button
                      class="btn btn-info spacer"
                      @click="verifyClaim"
                      v-if="
                        claimdetails.verified_by_id == null &&
                        user.job_title == 'Claims Verifier'
                      "
                    >
                      mark as verified <i class="fe fe-check"></i>
                    </button>
                    <a
                      target="_blank"
                      :href="`/patient/${claimdetails.enrollee.type}/${claimdetails.enrollee.id}`"
                      v-if="claimdetails.enrollee != null"
                    >
                      <button class="btn btn-outline-info spacer">
                        enrollee <i class="fe fe-user"></i>
                      </button>
                    </a>
                    <button
                      class="btn btn-success spacer"
                      @click="submitDraftClaim"
                      :disabled="draftBusy"
                      v-if="isFacilityUser && isDraftClaim"
                    >
                      Submit for Vetting <i class="fe fe-send"></i>
                    </button>

                    <button
                      class="btn btn-outline-secondary spacer"
                      @click="returnClaimToDraft"
                      :disabled="draftBusy"
                      v-if="isFacilityUser && canReturnToDraft"
                    >
                      Move Back to Draft <i class="fe fe-edit-3"></i>
                    </button>


                    <button
                      class="btn btn-outline-info spacer"
                      @click="show = !show"
                    >
                      Add Note <i class="fe fe-plus"></i>
                    </button>

                    <button
                      class="btn btn-info spacer"
                      @click="vetClaim"
                      v-if="
                        claimdetails.checked_by_id == null &&
                        user.job_title == 'Claims Vetter'
                      "
                    >
                      mark as vetted <i class="fe fe-check"></i>
                    </button>

                    <router-link
                      :to="{ path: '/edit-claim/' + claimdetails.id }"
                    >
                      <button
                        class="btn btn-warning spacer"
                        v-if="
                          claimdetails.status == 0 &&
                          user.type == 'provider_employee'
                        "
                      >
                        Update Claim Application
                      </button>
                    </router-link>

                    <button
                      class="btn btn-outline-info spacer"
                      @click="shownotes = !shownotes"
                    >
                      Notes {{ comments.length }}
                      <i class="fe fe-clipboard"></i>
                    </button>

                    <router-link
                      :to="{ path: '/upload-claims-docs/' + claimdetails.id }"
                    >
                      <button
                        class="btn btn-outline-info spacer"
                        v-if="claimdetails.status != 1"
                      >
                        Documents {{ singleclaim.docs.length }}
                        <i class="fe fe-file-plus"></i>
                      </button>
                    </router-link>

                    <router-link
                      :to="{
                        path: '/service-processing-form/' + claimdetails.id,
                      }"
                    >
                      <button
                        class="btn btn-outline-info spacer"
                        v-if="claimdetails.status != 1"
                      >
                        Services <i class="fe fe-thermometer"></i>
                      </button>
                    </router-link>

                    <router-link
                      :to="{
                        path: '/encounter/' + claimdetails.servicesummary.id,
                      }"
                      v-if="claimdetails.servicesummary != null"
                    >
                      <button
                        class="btn btn-outline-info spacer"
                        v-if="claimdetails.status != 1"
                      >
                        View Encounter <i class="fe fe-activity"></i>
                      </button>
                    </router-link>

                    <!-- <button
                      class="btn btn-danger"
                      style="margin-left: 10px"
                      @click="rejectClaim"
                      v-if="claimdetails.status != 1 && user.type == 'employee'"
                    >
                      <i class="fe fe-x"></i> Reject
                    </button> -->

                    <button
                      v-if="
                        user.job_title == 'Claims Verifier' ||
                        user.user_role != 0
                      "
                      class="btn btn-outline-info"
                      style="margin-left: 10px"
                      @click="addDrugDeductable"
                    >
                      <i class="fe fe-x"></i>
                      Deduct 10% Drugs
                    </button>

                    <button
                      class="btn btn-outline-info spacer"
                      @click="printMe"
                    >
                      Print <i class="fe fe-printer"></i>
                    </button>
                    <button
                      class="btn btn-outline-info spacer"
                      @click="AIVetClaims"
                    >
                      AI Vet <i class="mdi mdi-thought-bubble"></i>
                    </button>

                    <div class="form-group col-md-12" v-show="show">
                      <label for="inputAddress">Please add a Comment</label>
                      <textarea
                        name="name"
                        rows="5"
                        cols="80"
                        class="form-control"
                        v-model="body"
                      ></textarea>
                      <br />

                      <div class="form-group">
                        <button
                          type="button"
                          class="btn btn-info"
                          @click="addComment"
                        >
                          submit <i class="fe fe-send"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="">
            <div class="col-lg-8 col-md-8" v-show="shownotes">
              <div class="card m-b-30">
                <div class="card-body">
                  <div
                    class="card bg-default"
                    v-for="comment in comments"
                    v-bind:key="comment.id"
                    style="margin-top: 10px"
                  >
                    <div class="card-body">
                      <p class="">
                        {{ comment.body }}
                      </p>
                      <p class="text-info">
                        By: {{ comment.user.full_name }}
                        -
                        <span>{{ comment.user.type }}</span>
                      </p>
                      <p class="text-xs">
                        {{
                          comment.created_at
                            | moment("dddd, MMMM Do YYYY,  h:mm:ss a")
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="">
              <div class="col-lg-12 col-md-12">
                <div class="card">
                  <div class="card-header">
                    <strong class="h4">Claim Details</strong>
                  </div>

                  <div class="card-body">
                    <p>
                      <span v-if="claimdetails.status == 1">
                        <button
                          type="button"
                          class="btn m-b-15 ml-2 mr-2 badge badge-soft-info"
                        >
                          approved
                        </button>
                      </span>
                      <span v-if="claimdetails.status == 0">
                        <button
                          type="button"
                          class="btn m-b-15 ml-2 mr-2 badge badge-soft-danger"
                        >
                          rejected
                        </button>
                      </span>
                      <span v-if="isDraftClaim">
                        <button
                          type="button"
                          class="btn m-b-15 ml-2 mr-2 badge badge-soft-dark"
                        >
                          draft
                        </button>
                      </span>
                      <span v-if="claimdetails.status == null">
                        <button
                          type="button"
                          class="btn m-b-15 ml-2 mr-2 badge badge-soft-warning"
                        >
                          pending
                        </button>
                      </span>
                      <span v-if="claimdetails.checked_by_id != null">
                        <button
                          class="btn m-b-15 ml-2 mr-2 badge badge-soft-info"
                        >
                          vetted
                        </button>
                      </span>

                      <span v-if="claimdetails.verified_by_id != null">
                        <button
                          class="btn m-b-15 ml-2 mr-2 badge badge-soft-info"
                        >
                          verified
                        </button>
                      </span>

                      <span v-if="claimdetails.paymentorders.length >= 1">
                        <button
                          class="btn m-b-15 ml-2 mr-2 badge badge-soft-dark"
                          v-if="
                            claimdetails.paymentorders[0].status == 'pending'
                          "
                        >
                          processed for payment
                        </button>

                        <button
                          class="btn m-b-15 ml-2 mr-2 badge badge-soft-info"
                          v-if="claimdetails.paymentorders[0].status == 'paid'"
                        >
                          <i class="fe fe-check-square"></i>paid
                        </button>
                      </span>
                    </p>

                    <div class="row">
                      <div class="col-md-6">
                        <p>
                          <strong>Health Facility:</strong>
                          {{ claimdetails.provider.agency_name }}
                        </p>
                        <br />
                        <p>
                          <strong>Prepared by:</strong>
                          {{ prepared_by.full_name }}
                        </p>
                        <br />

                        <p v-if="claimdetails.auth_code != null">
                          <strong>Authorization Code:</strong>
                          <a
                            :href="`/authorization-code/${claimdetails.auth_code.id}`"
                            target="_blank"
                          >
                            {{ claimdetails.authorization_code }}
                          </a>
                        </p>
                        <br />
                        <p>
                          <strong>Enrollee Name:</strong>
                          <a
                            target="_blank"
                            v-if="claimdetails.enrollee != null"
                            :href="`/patient/${claimdetails.enrollee.type}/${claimdetails.enrollee.id}`"
                          >
                            {{ claimdetails.enrollee.full_name }} (
                            {{ claimdetails.enrollee.id_card_number }})
                          </a>
                        </p>
                        <br />
                        <p v-if="claimdetails.enrollee != null">
                          <strong>Enrollee DOB:</strong>
                          {{ claimdetails.enrollee.dob }}
                        </p>
                        <br />

                        <p v-if="claimdetails.enrollee != null">
                          <strong>Enrollee Phone Number:</strong>
                          {{ claimdetails.enrollee.phone_number }}
                        </p>
                        <br />
                        <p>
                          <strong>Is Enrollee Out of Station:</strong>
                          <span v-if="claimdetails.is_out_of_station == true">
                            Yes
                          </span>
                          <span v-if="claimdetails.is_out_of_station == false">
                            No
                          </span>
                        </p>
                        <br />
                        <p>
                          <strong>Date Created:</strong>
                          {{ claimdetails.created_at }}
                        </p>
                        <br />

                        <p v-if="claimdetails.diagnosis != null">
                          <strong>Diagnosis:</strong>
                          {{ claimdetails.diagnosis.name }}
                        </p>
                        <br />
                        <p>
                          <strong>Claim Treatment Level:</strong>
                          {{ claimdetails.claim_level }}
                        </p>
                        <br />
                      </div>

                      <div class="col-md-6">
                        <p>
                          <strong class="">Reason For Claim:</strong>
                          <span class="ml-2">{{ claimdetails.treatment }}</span>
                        </p>
                        <br />


                        <p>
                          <strong class="">Enounter Record:</strong>
                          <a class="ml-2 text-primary" target="_blank" :href="`/encounter/${singleclaim.encounter.id}`"> #{{  singleclaim.encounter.id }} </a>
                        </p>
                        <br />

                        <p>
                          <strong class="">Date of Admission:</strong>
                          <span class="ml-2">{{ singleclaim.encounter.date_of_admission }}</span>
                        </p>
                        <br />

                        <p>
                          <strong class="">Date of Discharge:</strong>
                          <span class="ml-2">{{ singleclaim.encounter.date_of_discharge }}</span>
                        </p>
                        <br />

                        <p v-if="claimdetails.checked_by_id != null">
                          <strong>Vetted By:</strong>
                          {{ claimdetails.checkeduser.full_name }}
                        </p>
                        <br />
                        <p v-if="claimdetails.verfieduser != null">
                          <strong>Verified By:</strong>
                          {{ claimdetails.verfieduser.full_name }}
                        </p>
                        <br />
                        <p v-if="claimdetails.approved_by_id != null">
                          <strong>Approved By:</strong>
                          {{ claimdetails.approveduser.full_name }}
                        </p>
                        <br />
                        <p>
                          <strong>Date Approved:</strong>
                          {{ claimdetails.approved_by_date }}
                        </p>
                        <br />

                        <p>
                          <strong>Date Verified:</strong>
                          {{ claimdetails.verified_by_date }}
                        </p>
                        <br />

                        <p>
                          <strong>Date Vetted:</strong>
                          {{ claimdetails.checked_by_date }}
                        </p>
                        <br />

                        <div v-if="claimdetails.paymentorders.length >= 1">
                          <p class="h4">Payment Details:</p>
                          <p>
                            <strong>Payment Order ID:</strong>
                            <a
                              :href="`/transaction/${claimdetails.paymentorders[0].id}`"
                              class="text-info"
                            >
                              {{ claimdetails.paymentorders[0].payment_number }}
                            </a>
                          </p>

                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-12 col-md-12 spacer">
              <div class="card m-b-30">
                <div class="card-header">
                  <p>
                    <strong
                      >Services/Drugs <i class="fe fe-thermometer"></i
                    ></strong>
                  </p>
                </div>

                <div class="card-body">
                  <p class="h3">Claim Service Breakdown:</p>

                  <div class="table-responsive">
                    <table class="table align-td-middle table-card">
                      <thead>
                        <tr>
                          <th>S/N.</th>
                          <th>Name</th>
                          <!-- <th>Unit Amount</th> -->
                          <th>Requested Cost</th>
                          <th>Vetted Amount</th>
                          <th>Verified Amount</th>
                          <th>Verdict</th>

                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(service, index) in singleclaim.services"
                          v-bind:key="service.id"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>
                            <span v-if="service.service != null">{{
                              service.service.description
                            }}</span>
                            <span v-if="service.drugs_id != null">{{
                              service.drug.drug_name
                            }}</span>
                          </td>
                          <!-- <td>
                            &#8358;
                            <span v-if="service.service != null">{{
                              service.service.price
                            }}</span>
                            <span v-if="service.drugs_id != null">{{
                              service.drug.price
                            }}</span>
                          </td> -->

                          <td>&#8358;{{ service.cost | numeral(0, 0) }}</td>
                          <td>
                            <span v-show="listprice">
                              &#8358;{{ service.vetted_price | numeral(0, 0) }}
                            </span>

                            <div
                              class="btn-group CTAs"
                              v-if="service.ai != null"
                            >
                              <button
                                type="button"
                                class="btn btn-info badge dropdown-toggle m-2"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                ₦{{ service.ai.vetted_price | numeral(0, 0) }}
                              </button>

                              <div class="dropdown-menu">
                                <button
                                  class="btn btn-success btn-block badge"
                                  href="#"
                                  @click="updateServicePrice(trf)"
                                >
                                  Accept
                                  <i class="fe fe-check"></i>
                                </button>
                                <button
                                  class="btn btn-danger btn-block badge"
                                  href="#"
                                  @click="updateprice_vet = true"
                                >
                                  Reject
                                  <i class="fe fe-x"></i>
                                </button>
                                <div class="dropdown-divider"></div>
                              </div>
                            </div>

                            <input
                              type="number"
                              class="form-control m-2"
                              v-show="updateprice_vet"
                              id=""
                              @change="updateServicePriceSingle(service)"
                              v-model="service.vetted_price"
                            />

                            <button
                              v-if="user.job_title == 'Claims Verifier'"
                              class="btn btn-success btn-block badge"
                              @click="acceptVettedAmount(service)"
                            >
                              Accept Vet
                              <i class="fe fe-check"></i>
                            </button>
                          </td>

                          <td>
                            <span v-show="listprice">
                              &#8358;{{
                                service.verified_price | numeral(0, 0)
                              }}
                            </span>
                            <input
                              type="number"
                              class="form-control"
                              :id="`price${service.id}`"
                              v-show="updateprice_ver"
                              @change="updateServicePriceSingle(service)"
                              v-model="service.verified_price"
                            />
                          </td>
                          <td>
                            <span v-if="service.remark != null">{{
                              service.remark.name
                            }}</span>
                          </td>

                          <td>
                            <button
                              data-toggle="modal"
                              data-target="#slideRightModalAll"
                              class="btn m-b-15 ml-2 mr-2 btn-outline-info"
                              @click="getSingleService(service)"
                            >
                              <i class="fe fe-eye"> </i>
                            </button>
                            <div
                              class="col-md-12"
                              v-if="claimdetails.status != 1"
                            >
                              <div
                                class="form-group"
                                v-if="service.id == selected_service"
                              >
                                <label for="inputCity">Select Verdict</label>
                                <select
                                  class="form-control"
                                  v-model="remark_selected"
                                  @change="updateService(service)"
                                >
                                  <option
                                    :value="remark.id"
                                    v-for="remark in remarks"
                                    v-bind:key="remark.id"
                                  >
                                    {{ remark.name }}
                                  </option>
                                </select>
                              </div>

                              <div v-else>
                                <div class="btn-group">
                                  <button
                                    type="button"
                                    class="btn btn-outline-info dropdown-toggle"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    v-if="
                                      user.type != 'provider_employee' &&
                                      user.type != 'provider' &&
                                      claimdetails.status != 1
                                    "
                                  >
                                    <i class="fe fe-edit"></i>
                                  </button>
                                  <div class="dropdown-menu">
                                    <a
                                      class="dropdown-item"
                                      @click="remarkService(service)"
                                    >
                                      make verdict</a
                                    >
                                    <div class="dropdown-divider"></div>
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      @click="readycommentService(service)"
                                      >add comment</a
                                    >
                                    <div class="dropdown-divider"></div>
                                    <a
                                      class="dropdown-item"
                                      @click="updateprice_vet = true"
                                      v-if="user.job_title == 'Claims Vetter'"
                                      >vet amount</a
                                    >
                                    <div class="dropdown-divider"></div>
                                    <a
                                      class="dropdown-item"
                                      v-if="
                                        user.type == 'shis' ||
                                        user.type == 'employee' ||
                                        user.job_title == 'Claims Verifier'
                                      "
                                      @click="updateprice_ver = true"
                                      >verify amount</a
                                    >
                                    <div class="dropdown-divider"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="2">
                            <strong>Total</strong>
                          </td>
                          <td>
                            <strong
                              >&#8358;{{
                                singleclaim.sum | numeral(0, 0)
                              }}</strong
                            >
                          </td>
                          <td>
                            <strong
                              >&#8358;{{
                                singleclaim.vetted_sum | numeral(0, 0)
                              }}</strong
                            >
                          </td>

                          <td>
                            <strong>
                              <span
                                >&#8358;{{
                                  singleclaim.verified_sum | numeral(0, 0)
                                }}</span
                              >
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- <p class="spacer">
                      <strong class="h5"
                        >Requested Total Amount of Service
                      </strong>
                      <strong class="h5"
                        >&#8358;{{ singleclaim.sum | numeral(0, 0) }}</strong
                      >
                    </p>

                    <p class="spacer">
                      <strong class="h5"
                        >Vetted Total Amount of Service
                      </strong>
                      <strong class="h5"
                        >&#8358;{{
                          singleclaim.vetted_sum | numeral(0, 0)
                        }}</strong
                      >
                    </p>
                    <p class="h5 spacer">
                      Approved Total Amount of Service
                      <span
                        >&#8358;{{
                          singleclaim.verified_sum | numeral(0, 0)
                        }}</span
                      >
                    </p> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- Modal -->
            <div
              class="modal fade modal-slide-right"
              id="slideRightModalAll"
              tabindex="-1"
              role="dialog"
              aria-labelledby="slideRightModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog scrollmodal" role="document">
                <div class="modal-content" id="printDiv" ref="printNow">
                  <div class="modal-header">
                    <h5 class="modal-title" id="slideRightModalLabel">
                      <span v-if="singlservicemodal.service != null">{{
                        singlservicemodal.service.description
                      }}</span>
                      <span v-if="singlservicemodal.drug != null"
                        >{{ singlservicemodal.drug.drug_name }}:
                        {{ singlservicemodal.drug.item_data }}
                      </span>
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body">
                    <p>
                      <span class="font-weight-bold">Unit Amount:</span>
                      &#8358;
                      <span v-if="singlservicemodal.service != null">{{
                        singlservicemodal.service.price
                      }}</span>
                      <span v-if="singlservicemodal.drugs_id != null">{{
                        singlservicemodal.drug.price
                      }}</span>
                    </p>

                    <p>
                      <span
                        class="font-weight-bold"
                        v-if="singlservicemodal.drug != null"
                        >Dose:
                      </span>
                      ({{ singlservicemodal.dose }}),
                      <span class="font-weight-bold">Frequency:</span> ({{
                        singlservicemodal.frequency
                      }}),

                      <span class="font-weight-bold">Days:</span> (
                      {{ singlservicemodal.days }}).
                    </p>

                    <p>
                      <span class="font-weight-bold">Verdict</span> :
                      <span v-if="singlservicemodal.remark != null">{{
                        singlservicemodal.remark.name
                      }}</span>
                    </p>
                    <br />
                    <p>
                      <span class="font-weight-bold">Requested Amount</span> :
                      &#8358;{{ singlservicemodal.cost }}
                    </p>
                    <br />

                    <p>
                      <span class="font-weight-bold">Vetted Amount</span> :
                      &#8358;{{ singlservicemodal.vetted_price }}
                    </p>
                    <br />

                    <p>
                      <span class="font-weight-bold">Approved Amount</span> :
                      &#8358;{{ singlservicemodal.verified_price }}
                    </p>
                    <br />

                    <section class="" v-if="user.type == 'employee'">
                      <div class="col-md-12">
                        <div class="row list">
                          <div class="">
                            <div class="card">
                              <div class="card-header h5 text-center">
                                Vet Center
                              </div>

                              <div class="card-body">
                                <div class="table-responsive">
                                  <table class="table">
                                    <thead>
                                      <tr>
                                        <th class="">Item</th>

                                        <th class="text-right">Value</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td class="">
                                          <p class="text-black m-0">Dose</p>
                                        </td>

                                        <td class="text-right">
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                              singlservicemodal.vetted_dose
                                            "
                                          />
                                        </td>
                                      </tr>

                                      <tr>
                                        <td class="">
                                          <p class="text-black m-0">
                                            Frequency
                                          </p>
                                        </td>

                                        <td class="text-right">
                                          <span>
                                            <input
                                              type="number"
                                              class="form-control"
                                              v-model="
                                                singlservicemodal.vetted_frequency
                                              "
                                            />
                                          </span>
                                        </td>
                                      </tr>

                                      <tr>
                                        <td class="">
                                          <p class="text-black m-0">Days</p>
                                        </td>

                                        <td class="text-right">
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                              singlservicemodal.vetted_days
                                            "
                                          />
                                        </td>
                                      </tr>
                                      <tr class="bg-light h5">
                                        <td class=""><strong>Total</strong></td>
                                        <td class="text-right">
                                          <i class="mdi mdi-currency-ngn"></i>
                                          <strong>
                                            {{
                                              singlservicemodal.vetted_price
                                                | numeral(0, 0)
                                            }}</strong
                                          >
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <div class="col-md-12">
                                  <button
                                    @click="
                                      updateServicePrice(singlservicemodal)
                                    "
                                    class="btn btn-outline-info btn-block"
                                  >
                                    Vet Item
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <!-- Comments -->
                    <div>
                      <p class="h4">Comments</p>

                      <div
                        v-for="comment in singlservicemodal.servicecomments"
                        v-bind:key="comment.id"
                        class=""
                      >
                        <b-card class="text-left">
                          <div class="bg-white text-dark">
                            {{ comment.body }}
                            <p>
                              <span class="text-primary"
                                >{{ comment.user.full_name }}
                              </span>
                              <span class="font-weight-light">
                                <small>
                                  {{
                                    comment.created_at | moment("from", "now")
                                  }}</small
                                >
                              </span>
                            </p>
                          </div>
                        </b-card>
                      </div>
                    </div>
                    <!-- End of Coments -->
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!--End of Modal -->

            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30">
                <div class="card-header">
                  <p>
                    <strong>Claim Documents <i class="fe fe-file"></i></strong>
                  </p>
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-td-middle table-card">
                      <thead>
                        <tr>
                          <th>S/N.</th>
                          <th>Name</th>
                          <th>Uploaded By</th>
                          <th>Date Uploaded</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(doc, index) in singleclaim.docs"
                          v-bind:key="doc.id"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ doc.name }}</td>
                          <td>
                            {{ doc.user.full_name }}
                          </td>
                          <td>{{ doc.created_at }}</td>
                          <td>
                            <a
                              :href="
                                'https://claimify-api.hayokmedicare.ng/documents/' +
                                doc.document
                              "
                              target="_blank"
                            >
                              <button
                                class="btn btn-outline-info"
                                name="button"
                              >
                                <i class="fe fe-eye"></i>
                              </button>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </section>
    </div>
    <Footer />
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import Footer from "@/views/Footer.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
let user = JSON.parse(localStorage.getItem("user"));

import claimDraftMixin from "./mixins/claimDraftMixin";

export default {
  mixins: [claimDraftMixin],
  components: {
    Navbar,
    Footer,
    Loading,
  },
  data() {
    return {
      user: user,
      singleclaim: "",
      comments: "",
      remarks: "",
      remark_selected: "",
      shownotes: false,
      updateprice_vet: false,
      updateprice_ver: false,
      listprice: true,
      facility: "",
      clientdetail: "",
      selected_service: "",
      body: "",
      claimdetails: {
        paymentorders: [],
      },
      prepared_by: "",
      singlservicemodal: "",
      show: false,
      isLoading: false,
      fullPage: true,
      agency_id: "",
    };
  },
  beforeMount() {
    this.axios.get(`/api/v1/auth/remarks/95930`).then((response) => {
      this.remarks = response.data;
      console.log(response);
    });
  },
  methods: {
    testID() {
      console.log("Hellp");
    },
    remarkService(service) {
      this.selected_service = service.id;
    },
    readycommentService(service) {
      this.selected_service = service.id;
      this.show = true;
      // this.addComment(service);
    },
    getClaim() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/detailedClaim/${this.$route.params.id}`)
        .then((response) => {
          this.singleclaim = response.data;
          this.comments = response.data.comments;
          this.claimdetails = response.data.singleclaim[0];

          // Prepared by
          this.axios
            .get(
              `/api/v1/auth/user/zam/${response.data.singleclaim[0].user_id}`
            )
            .then((response) => {
              this.prepared_by = response.data.user;
              console.log(response);
            });
          //end of Prepared by

          console.log(response);
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = true;
        });
    },

    addComment() {
      if (this.selected_service != "") {
        this.axios
          .post(`/api/v1/auth/addComment`, {
            user_id: this.user.id,
            claim_service_id: this.selected_service,
            body: this.body,
          })
          .then((response) => {
            console.log(response);
            this.getClaim();
            this.show = false;
            this.selected_service = "";
            this.body = "";
            this.$toasted.info("added Successfully!", {
              position: "top-center",
              duration: 3000,
            });
          });
      } else {
        this.axios
          .post(`/api/v1/auth/addComment`, {
            user_id: this.user.id,
            claim_id: this.$route.params.id,
            body: this.body,
          })
          .then((response) => {
            console.log(response);
            this.getClaim();
            this.show = false;
            this.$toasted.info("added Successfully!", {
              position: "top-center",
              duration: 3000,
            });
          });
      }
    },
    updateService(service) {
      this.axios
        .put(`/api/v1/auth/claim_service/${service.id}`, {
          user_id: this.user.id,
          claims_id: this.$route.params.id,
          services_id: service.services_id,
          drugs_id: service.drugs_id,
          cost: service.cost,
          remark_id: this.remark_selected,
        })
        .then((response) => {
          console.log(response);
          this.getClaim();
          this.show = false;
          this.$toasted.info("updated Successfully!", {
            position: "top-center",
            duration: 3000,
          });
          this.selected_service = "";
          this.remark_selected = "";
        });
    },

    updateServicePriceSingle(service) {
      this.axios
        .post(`/api/v1/auth/claim_service/update-cost`, {
          claims_service_id: service.id,

          dose: service.dose,
          frequency: service.frequency,
          days: service.days,

          vetted_dose: service.vetted_dose,
          vetted_frequency: service.vetted_frequency,
          vetted_days: service.vetted_days,

          verified_dose: service.verified_dose,
          verified_frequency: service.verified_frequency,
          verified_days: service.verified_days,

          vetted_price: service.vetted_price,
          verified_price: service.verified_price,
        })
        .then((response) => {
          console.log(response);
          this.getClaim();
          this.show = false;
          this.$toasted.info("Cost Updated Successfully!", {
            position: "top-center",
            duration: 3000,
          });
          this.selected_service = "";
        });
    },

    updateServicePrice(service) {
      let item_price =
        service.service == null ? service.drug.price : service.service.price;
      this.axios
        .post(`/api/v1/auth/claim_service/update-cost`, {
          claims_service_id: service.id,

          dose: service.dose,
          frequency: service.frequency,
          days: service.days,

          vetted_dose: service.vetted_dose,
          vetted_frequency: service.vetted_frequency,
          vetted_days: service.vetted_days,

          verified_dose: service.verified_dose,
          verified_frequency: service.verified_frequency,
          verified_days: service.verified_days,

          vetted_price:
            service.vetted_dose *
            service.vetted_frequency *
            service.vetted_days *
            item_price,
          // vetted_price: service.vetted_price,
          verified_price: service.verified_price,
        })
        .then((response) => {
          console.log(response);
          this.getClaim();
          this.show = false;
          this.$toasted.info("Cost Updated Successfully!", {
            position: "top-center",
            duration: 3000,
          });
          this.selected_service = "";
        });
    },

    acceptVettedAmount(service) {
      this.axios
        .post(`/api/v1/auth/claim_service/update-cost`, {
          claims_service_id: service.id,
          vetted_dose: service.vetted_dose,
          vetted_frequency: service.vetted_frequency,
          vetted_days: service.vetted_days,

          verified_dose: service.verified_dose,
          verified_frequency: service.verified_frequency,
          verified_days: service.verified_days,

          vetted_price: service.vetted_price,
          verified_price: service.vetted_price,
        })
        .then((response) => {
          console.log(response);
          this.getClaim();
          this.show = false;
          this.$toasted.info("Cost Updated Successfully!", {
            position: "top-center",
            duration: 3000,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    verifyClaim() {
      if (confirm("Are you sure you want to make verified?")) {
        this.axios
          .post(`/api/v1/auth/verify-claims/${this.$route.params.id}`, {
            claim_level: "Verification",
          })
          .then((response) => {
            console.log(response);
            this.$router.push(`/all-claims`);

            this.addDrugDeductable();
            this.$toasted.info("updated Successfully!", {
              position: "top-center",
              duration: 3000,
            });
          });
      }
    },
    vetClaim() {
      if (confirm("Are you sure you want to mark as vetted?")) {
        this.axios
          .post(`/api/v1/auth/checked-claims/${this.$route.params.id}`, {
            claim_level: "HMO",
          })
          .then((response) => {
            console.log(response);
            this.$router.push(`/all-claims`);
            this.getClaim();
            this.$toasted.info("vetted Successfully!", {
              position: "top-center",
              duration: 3000,
            });
          });
      }
    },

    getSingleService(service) {
      this.singlservicemodal = service;
    },
    printMe() {
      var printContents = document.getElementById("printDiv").innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
    },

    addDrugDeductable() {
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/claim_service", {
          services_id: 2019,
          claims_id: this.$route.params.id,
          days: 1,
          dose: 1,
          frequency: 1,
          verified_price: -this.singleclaim.revised_fee,
        })

        .then((response) => {
          console.log(response);
          this.getClaim();
          this.isLoading = false;
          this.$breadstick.notify("Added Successfully!", {
            position: "top-right",
          });
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
        });
    },
    AIVetClaims() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .post(`/api/v1/auth/ai-claims`, {
          claim_id: this.$route.params.id,
          agency_id: 95930,
          user: this.claimdetails.enrollee,
          items: this.singleclaim.services,
        })
        .then((response) => {
          let aiItems = response.data.data;
          // Combine AI to Items

          // Combine the two arrays
          this.singleclaim.services.forEach((item, index) => {
            if (aiItems[index]) {
              item.ai = aiItems[index];
            }
          });

          // Resulting array
          console.log(this.singleclaim.services);

          // End of Combination
          console.log(response);

          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getClaim();
  },
};
</script>
<style scoped>
.spacer {
  margin-top: 10px;
  margin-bottom: 10px;
}
.dropdown-menu {
  padding: 1rem;
}
.scrollmodal {
  overflow-y: scroll;
}
</style>
